import {httpPost} from './base'
// tab1 运营详情数据
export const loadLearnDetails = (params) => { return httpPost('learnDetails/learnDetails', params).then(res => res) }
export const loadSchoolStatistics = (params) => { return httpPost('learnDetails/schoolStatistics', params).then(res => res) }
export const loadQoocobarStatistics = (params) => { return httpPost('learnDetails/qoocobarStatistics', params).then(res => res) }
export const loadClubWeeks = (params) => { return httpPost('learnDetails/listComparedClubData', params).then(res => res) }



// WEBPACK FOOTER //
// ./src/api/learn-details.js